import React from 'react';
import ServiceCarousel from './ServiceCarousel';
import { useDiscountedServices, toArray } from '../../services/hooks/useCatalog';

const DiscountedServices = () => {
  const { data, isLoading } = useDiscountedServices();
  const items = toArray(data);

  return (
    <ServiceCarousel
      title="Best Deals & Offers"
      subtitle="Limited-time discounts"
      items={items}
      loading={isLoading}
    />
  );
};

export default DiscountedServices;
